export const adminSteps = [
  {
    selector: ".admin-step-1",
    content: "This is admin first Step",
  },
  {
    selector: ".admin-step-2",
    content: "This is admin Second Step",
  },
  {
    selector: ".admin-step-3",
    content: "This is admin third Step",
  },
];

export const userSteps = [
  {
    selector: ".dashboard-step-1",
    content: "This is user first Step",
  },
  {
    selector: ".assessment-step-2",
    content: "This is user second Step",
  },
  {
    selector: ".investment-ready-step-3",
    content: "This is user third Step",
  },
  {
    selector: ".training-step-4",
    content: "This is user fourth Step",
  },
  {
    selector: ".users-step-5",
    content: "This is user fifth Step",
  },
];
